// Форматирование дат и счётчиков блога. Месяцы задаём таблицей, а не локалью
// dayjs: в макете короткий месяц идёт без точки («12 дек 2025»), а ru-локаль
// dayjs пишет «12 дек. 2025».

const MONTHS_SHORT = [
  "янв",
  "фев",
  "мар",
  "апр",
  "мая",
  "июн",
  "июл",
  "авг",
  "сен",
  "окт",
  "ноя",
  "дек",
];

const MONTHS_LONG = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

// Бэк отдаёт «2026-08-05 12:05:41» — Safari такую строку через new Date()
// не разбирает, поэтому меняем пробел на T.
const toDate = (value?: string | null) => {
  if (!value) return null;
  const date = new Date(value.replace(" ", "T"));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const blogDateShort = (value?: string | null) => {
  const date = toDate(value);
  if (!date) return "";
  return `${String(date.getDate()).padStart(2, "0")} ${MONTHS_SHORT[date.getMonth()]} ${date.getFullYear()}`;
};

export const blogDateLong = (value?: string | null) => {
  const date = toDate(value);
  if (!date) return "";
  return `${date.getDate()} ${MONTHS_LONG[date.getMonth()]} ${date.getFullYear()}`;
};

// Для <time datetime="...">
export const blogDateIso = (value?: string | null) => {
  const date = toDate(value);
  return date ? date.toISOString() : "";
};

export const blogViews = (value?: number | null) =>
  typeof value === "number" ? value.toLocaleString("ru-RU") : "";
